module.exports = __webpack_public_path__ + "static/headerBg.dd0f6fec.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/AboutPage/headerBg.svg
// module id = 1004
// module chunks = 0